 <div class="scrollable-form-container d-flex">
  <!-- Trigger Form -->
  <form [formGroup]="triggerForm" class="form form-container">
    <div formArrayName="triggerLevels" >
        <div class="trigger-header pb-3">
            <b>{{ 'TRIGGER.TRIGGER_LEVELS' | translate }}</b>
            <div class="header-divider mt-2"></div>
        </div>

        <div class="row">
            <div *ngFor="let channel of triggerLevels.controls; let i = index" [formGroupName]="i" class="col-12 col-md-4 pb-3">
                <div class="d-flex">
                    <div class="switch d-flex">
                        <input type="checkbox" formControlName="isActive" id="switch-{{ i }}" />
                        <label for="switch-{{i}}"></label>
                        <b class="switch-label">{{ 'TRIGGER.CHANNEL' | translate }} {{ i + 1 }}</b>
                        <span *ngIf="i === 0">(V)</span>
                        <span *ngIf="i === 1">(L)</span>
                        <span *ngIf="i === 2">(T)</span>
                    </div>
                    <div *ngIf="i > 3">
                        <button class="btn btn-sm btn-light me-3 ms-5" type="button" (click)="removeChannel(i)">
                            <img src="icon/delete.svg" />
                          </button>  
                    </div>
                    <div class="radio-group" *ngIf="i > 2">
                        <label class="custom-radio" 
                               [ngClass]="{
                                   'fw-bold': triggerLevels.controls[i].get('unit')?.value === 'Pa',
                                   'disabled-radio': !triggerLevels.controls[i].get('isActive')?.value
                               }">
                            <input type="radio" formControlName="unit" value="Pa"  /> Pa
                        </label>
                        <label class="custom-radio" 
                               [ngClass]="{
                                   'fw-bold': triggerLevels.controls[i].get('unit')?.value === 'dB(L)',
                                   'disabled-radio': !triggerLevels.controls[i].get('isActive')?.value
                               }">
                            <input type="radio" formControlName="unit" value="dB(L)"  /> dB(L)
                        </label>
                        <label class="custom-radio" 
                               [ngClass]="{
                                   'fw-bold': triggerLevels.controls[i].get('unit')?.value === 'mm/s',
                                   'disabled-radio': !triggerLevels.controls[i].get('isActive')?.value
                               }">
                            <input type="radio" formControlName="unit" value="mm/s" /> mm/s
                        </label>
                    </div>
                    
                </div>
            
                <div class="channel-body">
                    <div class="row-item-width-50 input-group input-container">
                        <label for="triggerValue-{{ i }}" class="input-label">{{ 'TRIGGER.TRIGGER_VALUE' | translate }}</label>
                        <input id="triggerValue-{{ i }}" class="input-field with-placeholder" formControlName="triggerValue" />
                        <span class="unit">{{ getUnitValue(i) }}</span>
                    </div>
                </div>
            </div>
        </div>

        
      <div class="pb-3">
        <button class="btn btn-sm btn-light me-3" type="button" (click)="addTriggerChannel(1)"><img src="icon/add-circle.svg" class="me-2" />{{ 'TRIGGER.NEW_CHANNEL' | translate }}</button>
      </div>
    </div>


  </form>
    <div class="fixed-submit-container">
        <button *ngIf="isFormChanged" class="fixed-cancel-button btn btn-sm btn-light" (click)="resetForm()" type="button">Cancel</button>
        <button class="fixed-submit-button btn btn-light colored-button" type="submit" [disabled]="triggerForm.invalid" (click)="submitForm()"><img src="icon/save.svg" class="me-2" 
            />{{ 'TRIGGER.SAVE' | translate }}</button>
    </div>
    

</div>



      